import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import * as componentStore from '../../../component-store'
import { Store } from '../store'

/**
 * Tool bar for editing the org chart
 */
@ngCore.Component({
  imports: [ds.button.Component, ds.overlay.confirmation.Component],
  selector: 'atn-summit-org-chart-tools',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)
  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(componentStore.Widget)

  /**
   * Controls the confirmation dialog for clearing the org chart
   */
  public readonly confirmClearSg = ngCore.signal(false)
  /** TODO:  */
  private readonly _isCurrentEntrySg = ngCore.computed(
    (chartId = this.store.chartIdSg()) =>
      chartId &&
      state.mosaic.treeEditor.models.Chart.Entry.get(chartId) === 'current',
  )
  /** TODO:  */
  private readonly _isProposedEntrySg = ngCore.computed(
    (chartId = this.store.chartIdSg()) =>
      chartId &&
      state.mosaic.treeEditor.models.Chart.Entry.get(chartId) === 'proposed',
  )
  /** TODO:  */
  public readonly chartCurrentIdSg = ngCore.computed(
    (
      isCurrentEntry = this._isCurrentEntrySg(),
      chartId = this.store.chartIdSg(),
    ) =>
      isCurrentEntry &&
      chartId &&
      (chartId satisfies state.mosaic.treeEditor.models.Chart.Id as state.mosaic.treeEditor.models.Chart.Id<
        string,
        'current'
      >),
  )
  /** TODO: */
  public readonly chartProposedIdSg = ngCore.computed(
    (
      isProposedEntry = this._isProposedEntrySg(),
      chartId = this.store.chartIdSg(),
    ) =>
      isProposedEntry &&
      chartId &&
      (chartId satisfies state.mosaic.treeEditor.models.Chart.Id as state.mosaic.treeEditor.models.Chart.Id<
        string,
        'proposed'
      >),
  )

  /** Returns whether the active chart is fully expanded in Cytoscape. */
  public isAllNodesExpanded(): boolean {
    const chartId = this.store.chartIdSg()
    if (!chartId) {
      return false
    }
    return this.store.treeEditorFeature.cytoscapeManager.isAllNodesExpanded({
      chartId,
    })
  }

  /** Toggles the active chart between collapsed and fully expanded states. */
  public toggleExpandCollapseAll(): void {
    const chartId = this.store.chartIdSg()
    if (!chartId) {
      return
    }
    this.store.treeEditorFeature.cytoscapeManager.toggleExpandCollapseAll({
      chartId,
    })
  }
}
